const textProps = {
  rating: 4.5,
  text: "76 customer reviews",
};
export default textProps;
